'use client';

import EligibilityGatedLink from 'components/EligibilityGatedLink';
import ArrowCircleRightIcon from 'components/icons/ArrowCircleRightIcon';
import { captureConversationStarted } from 'lib/analytics';

const HumanaGetStarted: React.FC = () => {
  return (
    <section className="get-started-section">
      <h2>
        Are you ready to skip the guesswork and pick the{' '}
        <b>right plan for you</b>?
      </h2>
      <EligibilityGatedLink
        href="/check-audio"
        className="get-started-button"
        gtmEvent="GetStartedClick"
        onClick={() => captureConversationStarted('humana_get_started')}
      >
        <span>Help me understand my options</span>
        <ArrowCircleRightIcon color="purple" />
      </EligibilityGatedLink>
    </section>
  );
};

export default HumanaGetStarted;
